export interface MenuItem {
  id: number;
  name: string;
  englishName?: string;
  description?: string;
  price?: string;
  category: string;
  subcategory?: string;
  image: string;
  isNew: boolean;
  isHot: boolean;
  isIce: boolean;
  spiceLevel?: number;
}

const menuImage = (filename: string) =>
  `/assets/HongdaePocha/HongdaePocha_Menu_Image/${filename}`;
const legacyImage = (filename: string) =>
  `/assets/HongdaePocha/HongdaePocha_image/${filename}`;
const newMenuImage = (filename: string) =>
  `/assets/HongdaePocha/HongdaePocha_Menu_Image_2027/${filename}`;

const englishFoodNames: Record<number, string> = {
  1: "Soy Glazed Wagyu Brisket",
  2: "Wagyu Oyster Blade",
  3: "Wagyu Bavette",
  4: "Soy Marinated Wagyu Karubi Plate",
  5: "LA Galbi",
  6: "Wagyu Rib Fingers",
  7: "Garlic Wagyu Jumulleok",
  8: "Pork Belly",
  9: "Extra Fatty Pork Belly",
  10: "Pork Scotch Fillet",
  11: "Pork Jowl",
  12: "Marinated Pork Galbi",
  13: "Wagyu Short Rib",
  14: "Wagyu Chuck Tail Flap",
  15: "Wagyu Tenderloin Side Strap",
  16: "Garlic Patagonian Red Prawns",
  17: "Lettuce Wraps",
  18: "Assorted Grilled Mushrooms",
  19: "Soy Pickled Garlic Leaves",
  20: "Sesame Oil Confit Garlic",
  21: "Spicy Spring Onion Salad",
  22: "Fermented Fish Dipping Sauce",
  23: "Beef Tartare Hash Browns",
  24: "Korean Steamed Egg",
  25: "Korean Beef Tartare",
  26: "Prawn Minari Pancake",
  27: "Tteokbokki",
  28: "Rose Tteokbokki",
  29: "Sotteok Sotteok",
  30: "Wagyu Doenjang Stew",
  31: "Pork Kimchi Stew",
  32: "Seafood Silken Tofu Stew",
  33: "Vegetable Bibimbap",
  34: "Wagyu Beef Tartare Bibimbap",
  35: "Cold Broth Naengmyeon",
  36: "Spicy Bibim Naengmyeon",
  37: "Spicy Stir-Fried Pork",
  38: "Pocha Udon",
  39: "Wagyu Chapagetti",
  40: "Sweet Potato Cheese Buldak",
  41: "Scorched Rice Wagyu Doenjang Hot Pot",
  42: "Spam Kimchi Hot Pot",
};

const item = (
  id: number,
  name: string,
  description: string,
  price: string,
  category: string,
  subcategory: string | undefined,
  image = "",
): MenuItem => ({
  id,
  name,
  englishName: englishFoodNames[id],
  description,
  price,
  category,
  subcategory,
  image,
  isNew: false,
  isHot: false,
  isIce: false,
});

const drink = (
  id: number,
  name: string,
  englishName: string,
  price: string,
  subcategory: string,
  description = "",
  image = "",
): MenuItem => ({
  id,
  name,
  englishName,
  description,
  price,
  category: "DRINKS",
  subcategory,
  image,
  isNew: false,
  isHot: false,
  isIce: false,
});

export const menuData: MenuItem[] = [
  // 2027 Summer food menu — BBQ Meats
  item(2, "부채살", "Oyster blade, Wagyu MBS6-7 (DF, GF)", "$19.90", "BBQ Meats", undefined, newMenuImage("1.webp")),
  item(3, "치마살", "Bavette, Wagyu MBS9+ (DF, GF)", "$19.90", "BBQ Meats", undefined, legacyImage("Chimasal.jpg")),
  item(4, "양념 업진살", "Soy marinated karubi plate, Wagyu MBS9+ (DF)", "$19.90", "BBQ Meats", undefined, menuImage("BandiView_5.webp")),
  item(5, "LA갈비", "Galbi sauce marinated LA cut ribs, Grass fed Black Angus (200g) (DF)", "$19.90", "BBQ Meats", undefined, newMenuImage("6.webp")),
  item(1, "우삼겹", "Soy glazed thin Wagyu brisket (DF)", "$19.90", "BBQ Meats", undefined),

  item(6, "갈비살", "Rib fingers, Wagyu MBS4-5 (DF, GF)", "$24.90", "BBQ Meats", undefined, legacyImage("galbisal.jpg")),
  item(7, "마늘주물럭", "Garlic marinated rib finger jumuluk, Wagyu MBS4-5 (DF, GF)", "$24.90", "BBQ Meats", undefined, newMenuImage("3.webp")),
  item(8, "삼겹살", "Free ranged pork belly (DF, GF)", "$24.90", "BBQ Meats", undefined, newMenuImage("7.webp")),
  item(9, "미식가용 삼겹살", "Free ranged extra fatty pork belly (limited) (DF, GF)", "$24.90", "BBQ Meats", undefined, newMenuImage("4.webp")),
  item(10, "목살", "Free ranged pork scotch fillet (DF, GF)", "$24.90", "BBQ Meats", undefined, menuImage("BandiView_69.webp")),
  item(11, "항정살", "Pork jowl (DF, GF)", "$24.90", "BBQ Meats", undefined, newMenuImage("8.webp")),
  item(12, "돼지갈비", "Free ranged pork rib meat marinated with soy & apple (DF)", "$24.90", "BBQ Meats", undefined, newMenuImage("13.webp")),

  item(13, "꽃살", "Short rib meat, Wagyu MBS6-7 (DF, GF)", "$34.90", "BBQ Meats", undefined, newMenuImage("5.webp")),
  item(14, "살치살", "Chuck tail flap, Wagyu MBS6-7 (DF, GF)", "$34.90", "BBQ Meats", undefined, newMenuImage("2.webp")),
  item(15, "안심추리", "Full blood Wagyu tenderloin side strap (GF, DF)", "$34.90", "BBQ Meats", undefined),
  item(16, "새우구이", "Patagonian prawn with garlic sauce (200g) (I) (GF, DF)", "$34.90", "BBQ Meats", undefined, newMenuImage("14.webp")),

  // K-BBQ's Friends
  item(17, "쌈", "Lettuce wraps (GF, DF, VG)", "$5", "K-BBQ's Friends", undefined, legacyImage("Ssam.jpg")),
  item(18, "버섯구이", "Assorted mushrooms with garlic soy dressing (DF, VG)", "$16", "K-BBQ's Friends", undefined, menuImage("BandiView_50.webp")),
  item(19, "명이나물", "Soy pickled garlic leaf (DF, VG)", "$7", "K-BBQ's Friends", undefined, menuImage("BandiView_51.webp")),
  item(20, "참기름마늘구이", "Confit garlic with sesame oil (GF, DF, VG)", "$5", "K-BBQ's Friends", undefined, newMenuImage("26.webp")),
  item(21, "파무침", "Spring onion salad with sesame oil vinaigrette and chilli (GF, DF, VG)", "$9", "K-BBQ's Friends", undefined),
  item(22, "갈치속젓", "Korean fish sauce dip (recommended with pork) (I) (GF, DF)", "$6", "K-BBQ's Friends", undefined),

  // Sides
  item(23, "육회 해시브라운", "Jinju style spicy beef tartare on golden hash brown, 2PCS (DF)", "$21", "Sides", undefined, newMenuImage("17.webp")),
  item(24, "계란찜", "Korean steamed egg (GF, DF)", "$19", "Sides", undefined, legacyImage("poktanegg.jpg")),
  item(25, "육회", "Korean style raw beef with rocket salad (GF, DF)", "$34", "Sides", undefined, menuImage("BandiView_29.webp")),
  item(26, "새우 미나리전", "Korean water parsley pancake with prawns (I) (DF)", "$27", "Sides", undefined, legacyImage("saewoominarijeon.jpg")),
  item(27, "떡볶이", "Tteokbokki, spicy gochujang rice cakes (I) (DF)", "$16", "Sides", undefined, newMenuImage("23.webp")),
  item(28, "로제떡볶이", "Rosé Tteokbokki, creamy gochujang rice cakes with cheese kransky (I)", "$25", "Sides", undefined, newMenuImage("22.webp")),
  item(29, "소떡소떡", "Rice cake, cheese kransky and potato gem in gochujang sauce", "$23", "Sides", undefined, newMenuImage("18.webp")),

  // Bowls, Plates & Hot Pots
  item(30, "소고기 된장찌개", "Doenjang stew with Wagyu, tofu and a bowl of rice (DF)", "$23", "Bowls, Plates & Hot Pots", undefined, menuImage("BandiView_12.webp")),
  item(31, "돼지고기 김치찌개", "Kimchi stew with pork, tofu and a bowl of rice (DF)", "$28", "Bowls, Plates & Hot Pots", undefined, menuImage("BandiView_13.webp")),
  item(32, "해물 순두부찌개", "Silken tofu stew with squid, prawn, clams and egg, served with a bowl of rice (I) (DF)", "$28", "Bowls, Plates & Hot Pots", undefined, newMenuImage("15.webp")),
  item(33, "양푼비빔밥", "Bibimbap with fried egg and vegetables (DF, V)", "$24", "Bowls, Plates & Hot Pots", undefined, menuImage("BandiView_18.webp")),
  item(34, "육회비빔밥", "Bibimbap with raw 9+ Wagyu and vegetables (DF)", "$29", "Bowls, Plates & Hot Pots", undefined, menuImage("BandiView_21.webp")),
  item(35, "물냉면", "Naengmyeon, Korean noodle with cold broth (DF)", "$22", "Bowls, Plates & Hot Pots", undefined, newMenuImage("27.webp")),
  item(36, "비빔냉면", "Bibim-Naengmyeon, Korean cold noodle with spicy sauce (DF)", "$24", "Bowls, Plates & Hot Pots", undefined, newMenuImage("28.webp")),
  item(37, "제육볶음", "Spicy stir fried pork belly on sizzling plate and a bowl of rice (DF)", "$26", "Bowls, Plates & Hot Pots", undefined, legacyImage("jeyuk.jpg")),
  item(38, "포차우동", "Korean pocha style udon noodle soup with fishcake (I) (DF)", "$26", "Bowls, Plates & Hot Pots", undefined),
  item(39, "우삼겹짜파게티", "Chapagetti with thin Wagyu brisket, chilli and garlic (DF)", "$25", "Bowls, Plates & Hot Pots", undefined, newMenuImage("19.webp")),
  item(40, "고구마치즈불닭", "Sizzling chilli cheese chicken with sweet potato cream (for 2-3)", "$52", "Bowls, Plates & Hot Pots", undefined, newMenuImage("20.webp")),
  item(41, "누룽지차돌된장술밥", "Doenjang hot pot with Wagyu and scorched rice (DF) (for 2-3)", "$49", "Bowls, Plates & Hot Pots", undefined, newMenuImage("21.webp")),
  item(42, "스팸김치전골", "Kimchi hot pot with spam, pork and tofu (DF) (for 2-3)", "$59", "Bowls, Plates & Hot Pots", undefined, newMenuImage("16.webp")),

  // Drinks
  drink(101, "참이슬", "Chamisul Fresh", "$20", "SOJU"),
  drink(102, "처음처럼", "Chumchurum", "$20", "SOJU", "", legacyImage("Chumchurum.jpg")),
  drink(103, "진로", "Jinro", "$20", "SOJU"),
  drink(104, "새로", "Saero", "$20", "SOJU", "", legacyImage("sero.jpg")),
  drink(105, "참이슬 오리지널", "Chamisul Original", "$25", "SOJU"),
  drink(106, "대선", "Daesun", "$19", "SOJU"),
  drink(107, "복숭아", "Soonhari Peach", "$19", "SOJU", "Flavoured soju", legacyImage("soonpeach.jpg")),
  drink(108, "청포도", "Soonhari Green Grape", "$19", "SOJU", "Flavoured soju", legacyImage("soongrape.jpg")),
  drink(109, "요구르트", "Soonhari Yogurt", "$19", "SOJU", "Flavoured soju", legacyImage("soonyogurt.jpg")),
  drink(110, "유자", "Soonhari Citron", "$19", "SOJU", "Flavoured soju"),
  drink(111, "딸기", "Soonhari Strawberry", "$19", "SOJU", "Flavoured soju"),

  drink(112, "카스", "Cass", "$9", "BEER", "", legacyImage("Cass.jpg")),
  drink(113, "테라", "Terra", "$9", "BEER"),
  drink(114, "크러쉬", "Krush", "$9", "BEER", "", legacyImage("krush.jpg")),
  drink(115, "Heaps Normal", "Non-alcoholic beer", "$10", "BEER"),

  drink(116, "지평", "Jipyeong Makgeolli", "$17", "MAKGEOLLI", "", legacyImage("jipungMakgeolli.jpg")),
  drink(117, "알밤", "Chestnut Makgeolli", "$17", "MAKGEOLLI", "", legacyImage("Chestnut.jpg")),

  drink(118, "Veuve D'Argent Cuvée Prestige", "Sparkling Wine · Bourgogne, France", "$57", "WINE"),
  drink(119, "Pencarrow", "Sauvignon Blanc · Martinborough, NZ", "$68", "WINE"),
  drink(120, "Jim Barry Lodge Hill", "Riesling · Clare Valley", "$73", "WINE"),
  drink(121, "Forest Hill Vineyard Estate", "Chardonnay · Mount Barker", "$76", "WINE"),
  drink(122, "Chaffey Bros La Conquista", "Tempranillo, Graciano & Grenache · Barossa Valley", "$68", "WINE"),
  drink(123, "Brokenwood", "Shiraz · Hunter Valley", "$88", "WINE"),

  drink(124, "별빛청하", "Chungha Sparkling Wine", "$16", "KOREAN WINE", "", legacyImage("sparkingwine.jpg")),
  drink(125, "복분자", "Korean Black Raspberry Wine", "$28", "KOREAN WINE", "", legacyImage("bokbunja.jpg")),

  drink(126, "유자소주", "Yuzu Soju", "$18", "COCKTAILS", "Yuzu, lychee"),
  drink(127, "수박소주", "Watermelon Soju", "$18", "COCKTAILS", "Strawberry, watermelon, vodka"),
  drink(128, "복담주", "Bokdamju", "$18", "COCKTAILS", "Bokbunja, condensed milk"),

  drink(129, "마차 막걸리", "Matcha Makgeolli", "$47", "SHARING COCKTAILS", "Matcha, condensed milk · For 2–4"),
  drink(130, "복소사", "Boksosa", "$49", "SHARING COCKTAILS", "Bokbunja, soju, Sprite · For 2–4"),

  drink(131, "코카콜라", "Coke", "$5.5", "SOFT DRINKS"),
  drink(132, "코카콜라 제로", "Coke No Sugar", "$5.5", "SOFT DRINKS"),
  drink(133, "스프라이트", "Sprite", "$5.5", "SOFT DRINKS"),
  drink(134, "스프라이트 제로", "Sprite No Sugar", "$5.5", "SOFT DRINKS"),
  drink(135, "밀키스", "Milkis", "$5.5", "SOFT DRINKS", "", legacyImage("creamsoda.jpg")),
  drink(136, "봉봉", "Bongbong Grape Juice", "$5.5", "SOFT DRINKS", "", legacyImage("bongbong.jpg")),
  drink(137, "갈아만든 배", "Pear Juice", "$5.5", "SOFT DRINKS", "", legacyImage("LDH.jpg")),

  drink(138, "서울토닉 숙취해소제", "Seoul Tonic", "$10.5", "REFRESH & RECOVERY", "Hangover relief drink"),
  drink(139, "탄산수", "Sparkling Water", "$8", "REFRESH & RECOVERY"),
  drink(140, "녹차", "Hot Green Tea", "$6.5", "REFRESH & RECOVERY"),
];
